// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageParent__PageParent__AlVRH{overflow-y:auto;overflow-x:hidden;max-width:85.714rem;margin:0 auto;width:100%;padding:0 1rem;box-sizing:border-box}
`, "",{"version":3,"sources":["webpack://./src/js/apps/components/common/PageParent/PageParent.scss"],"names":[],"mappings":"AAAA,+BACI,eAAgB,CAChB,iBAAkB,CAClB,mBAAoB,CACpB,aAAc,CACd,UAAW,CACX,cAAe,CACf,qBAAsB","sourcesContent":[".PageParent {\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-width: 85.714rem;\n    margin: 0 auto;\n    width: 100%;\n    padding: 0 1rem;\n    box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PageParent": `PageParent__PageParent__AlVRH`
};
export default ___CSS_LOADER_EXPORT___;
